export default __webpack_public_path__ + "static/media/provisionalLandingImageAflac.754fd139.jpg";